import { render, staticRenderFns } from "./eventosTable.vue?vue&type=template&id=34d25b36"
import script from "./eventosTable.vue?vue&type=script&lang=js"
export * from "./eventosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports